import styled from 'styled-components';
import { GridRow } from 'ui/indexPages/tables/grid';
import { Skeleton } from 'ui/skeleton';
import { pxToRem } from 'utils/convert';

const StyledSkeleton = styled(Skeleton)`
  height: ${pxToRem(44)};
`;

const rows = [1, 2, 3, 4, 5, 6, 7, 8];

const cells = [1, 2, 3, 4, 5, 6, 7, 8];

export const SkeletonRows = ({
  gridLayout,
  numColumns,
}: {
  gridLayout: string;
  numColumns: number;
}) =>
  rows.map((n) => (
    <GridRow key={n} gridLayout={gridLayout} data-test="skeleton-row">
      {cells.slice(0, numColumns).map((o) => (
        <StyledSkeleton key={o} />
      ))}
    </GridRow>
  ));
